import { string } from "yup";

export const postCode = () =>
  string()
    .required("Post Code is missing")
    .when("country", ([country]) => {
      return country === "USA"
        ? string()
            .required("Post Code is missing")
            .length(5, "Post code must be 5 digits")
        : string()
            .required("Post Code is missing")
            .length(7, "Post code must be Canadian format - e.g. 'A1A 1A1'");
    });
